<script setup lang="ts">
import { usePopupManager } from "@/shared/composables/usePopupManager";

// ui
import Button from "@/shared/components/button/Button.vue";

// interface
import type { AlertReconfirmEventPopupProps } from "@/shared/plugins/interface";

const props = defineProps<AlertReconfirmEventPopupProps>();
const { closePopup } = usePopupManager();

// button string
const alertConfirmButtonString = props.rest.confirmButtonName || "확인";
const alertCancelButtonString = props.rest.cancelButtonName || "이전";

/**
 * @description 취소 버튼 클릭 이벤트
 */
const clickCancelButton = () => {
    // 만일 취소 후 해야할 로직이 있다면
    if (props.rest.cancelCallback) {
        props.rest.cancelCallback();
    }

    closePopup(props.closeKey);
};

/**
 * @description 확인 버튼 클릭 이벤트
 */
const clickConfirmButton = async () => {
    await new Promise((resolve) => {
        closePopup(props.closeKey);
        resolve(true);
    }).then(async () => {
        if (props.rest.confirmCallback) {
            await props.rest.confirmCallback();
        }
    });
};
</script>

<template>
    <section class="flex flex-col justify-center items-center size-full">
        <div
            class="mb-[3.2rem] flex h-auto w-full flex-col items-center justify-center gap-[0.8rem]"
        >
            <p className="font-pretended text-base font-semibold text-primary-red">
                {{ props.rest.subTitle || "경고" }}
            </p>
            <h2 class="font-semibold text-center whitespace-pre-wrap text-md text-primary-black">
                {{ props.rest.title }}
            </h2>
        </div>
        <div class="flex h-auto w-full min-w-[30rem] items-center justify-center gap-[1.2rem]">
            <Button
                :type="'button'"
                :color="'primary-border'"
                :value="alertCancelButtonString"
                :disabled="false"
                :is-width-full="true"
                @click="clickCancelButton"
            />
            <Button
                :type="'button'"
                :color="'primary'"
                :value="alertConfirmButtonString"
                :disabled="false"
                :loading="rest.confirmCallbackPanding"
                :is-width-full="true"
                @click="clickConfirmButton"
            />
        </div>
    </section>
</template>
